// Google アナリティクス（GA4）。検索から何人来て、何人が資料請求・お問い合わせをしたかを数える（2026-10-19 代表指示。
// 営業資料「内製化支援のWeb・SNSマーケティング」v0.1 の「受け皿を整える」の1つ目）。
// 測定 ID（G-XXXXXXXXXX）はビルド時の環境変数 REACT_APP_GA_MEASUREMENT_ID で渡す。無いビルドでは何もしない
// （手元の開発・試験のビルドから本番の数字に混ざらないように、既定は空）。本番は .github/workflows/deploy-homepage.yml が
// リポジトリの変数 GA_MEASUREMENT_ID を渡す。測定 ID は公開してよい値（ページの HTML に出る）。
// 利用はプライバシーポリシーの「アクセス解析ツールの利用」に書いてある。氏名・メールなど個人を識別できる情報は送らない。
//
// Google 広告のタグ（2026-11-05 代表了承の検索広告）。ID（AW-XXXXXXXXX）は REACT_APP_GOOGLE_ADS_ID、資料請求の成果の
// ラベルは REACT_APP_GOOGLE_ADS_DOCUMENT_LABEL で渡す（どちらも公開してよい値。無いビルドでは広告のタグを入れない）。
// タグは広告のクリックの印（gclid）をこのサイトの Cookie に残し、資料請求の完了を成果として送る。お問い合わせは
// 売り込みが多いので画面からは送らず、AI が「製品の相談」と分けたものだけを受付の記録から送る（lambda/lead-api/README.md）。
// 使うのは効果の測定だけで、閲覧の記録を使った広告（リマーケティングなど）には使わない（allow_ad_personalization_signals:
// false。プライバシーポリシー第9条）。GA の出来事（trackEvent）は GA にだけ送り、広告のタグには届けない。
export const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || '';
export const GOOGLE_ADS_ID = /^AW-\d+$/.test(process.env.REACT_APP_GOOGLE_ADS_ID || '') ? process.env.REACT_APP_GOOGLE_ADS_ID : '';
export const GOOGLE_ADS_DOCUMENT_LABEL = process.env.REACT_APP_GOOGLE_ADS_DOCUMENT_LABEL || '';

const isPrerender = () => typeof window !== 'undefined' && Boolean(window.__SALT2_PRERENDER__);

const tagIds = () => [GA_MEASUREMENT_ID, GOOGLE_ADS_ID].filter(Boolean);

const enabled = () => tagIds().length > 0 && typeof window !== 'undefined' && !isPrerender();

let started = false;

/** gtag.js を読み込み、設定する。ページの表示は trackPageView で送る（画面の切り替えごとに自分で送る）。 */
export function startAnalytics() {
  if (started || !enabled()) return;
  started = true;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    // gtag.js は arguments オブジェクトそのものを受け取る決まり
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  if (GA_MEASUREMENT_ID) window.gtag('config', GA_MEASUREMENT_ID, { send_page_view: false });
  if (GOOGLE_ADS_ID) window.gtag('config', GOOGLE_ADS_ID, { allow_ad_personalization_signals: false });
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(tagIds()[0])}`;
  document.head.appendChild(script);
}

/** ページの表示を1回送る。題名は各ページの usePageMeta が付けたもの。 */
export function trackPageView() {
  if (!started || !window.gtag || !GA_MEASUREMENT_ID) return;
  window.gtag('event', 'page_view', {
    page_location: window.location.href,
    page_path: `${window.location.pathname}${window.location.search}`,
    page_title: document.title,
    send_to: GA_MEASUREMENT_ID,
  });
}

/** 出来事を送る（例: 資料請求の完了）。値に個人を識別できる情報を入れない。 */
export function trackEvent(name, params = {}) {
  if (!started || !window.gtag || !GA_MEASUREMENT_ID) return;
  window.gtag('event', name, { ...params, send_to: GA_MEASUREMENT_ID });
}

/** Google 広告に成果を1件送る。kind: 'document'（資料請求）。ID やラベルが無いビルドでは何もしない。 */
export function trackAdsConversion(kind) {
  if (!started || !window.gtag || !GOOGLE_ADS_ID) return;
  const label = kind === 'document' ? GOOGLE_ADS_DOCUMENT_LABEL : '';
  if (!label) return;
  window.gtag('event', 'conversion', { send_to: `${GOOGLE_ADS_ID}/${label}` });
}
